import { render } from "./BaseCard.vue?vue&type=template&id=56c19fcd&scoped=true&bindings={\"theme\":\"props\"}"
import script from "./BaseCard.vue?vue&type=script&lang=js"
export * from "./BaseCard.vue?vue&type=script&lang=js"

import "./BaseCard.vue?vue&type=style&index=0&id=56c19fcd&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-56c19fcd"

export default script